import React from 'react';

const MeetTheTeam = () => {
  return (
    <div>
      Meet The Team Page
    </div>
  );
};

export default MeetTheTeam;